// extracted by mini-css-extract-plugin
export default {"wtb_container":"WhereToBuyModem_wtb_container__KP9m-","btn_container":"WhereToBuyModem_btn_container__b8ASC","gts_link":"WhereToBuyModem_gts_link__PBwuZ"};